const ActionTypes = {
    /** WEB TOOL 1 ACTIONS **/
    APPEND_IMPROVEMENT: "APPEND_IMPROVEMENT",
    UPDATE_IMPROVEMENT: "UPDATE_IMPROVEMENT",
    DELETE_IMPROVEMENT: "DELETE_IMPROVEMENT",
    SET_IMPROVEMENT: "SET_IMPROVEMENT",
    UPDATE_STEP: "UPDATE_STEP",
    RESET_IMPROVEMENTS: "RESET_IMPROVEMENTS",
    CONTINUE_CLICKED: "CONTINUE_CLICKED",
    /** Phase 1 and Phase 2 ACTION **/
    SET_VALIDATION_DATA: 'SET_VALIDATION_DATA',
  
  /** CONFIG ACTIONS **/
  ADD_CPI_CONFIG: "ADD_CPI_CONFIG",
};

export default ActionTypes;
